import FormularioRD from '../rdstation/formularioRD';
import { useModal } from '../contexts/ModalContext';

export default function TecnologiasUtilizadas() {
  const { openModal } = useModal();
  return (
    <section className="bg-[#040116] text-white">
      <div className="container mx-auto xl:max-w-6xl pt-28 pb-40 flex flex-col items-center gap-16">
        <h2 className="text-5xl font-inter-regular text-center">
          Tecnologias utilizadas
        </h2>

        <img src="../assets/logotipos.png" alt="" className="block" />

        <button
          onClick={() => openModal(<FormularioRD />)}
          className="bg-white py-2 px-6 rounded-full font-inter-light text-xl hover:scale-105 transition-transform duration-300 cursor-pointer"
        >
          <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-transparent bg-clip-text">
            Conheça nossas soluções
          </span>
        </button>
      </div>
    </section>
  )
}
